import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Contacts(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.369 1c1.654 0 3 1.346 3 3v15.817c0 1.655-1.346 3-3 3H6.646c-1.654 0-3-1.345-3-3v-1.159H3a1 1 0 010-2h.646v-3.64H3a1 1 0 010-2h.646v-3.64H3a1 1 0 010-2h.646V4c0-1.654 1.346-3 3-3H19.37zm0 2H6.646c-.55 0-1 .449-1 1v1.378h.162a1 1 0 010 2h-.162v3.64h.162a1 1 0 010 2h-.162v3.64h.162a1 1 0 010 2h-.162v1.159c0 .552.45 1 1 1H19.37c.55 0 1-.448 1-1V4c0-.551-.45-1-1-1zm-5.633 9.037c1.172 0 2.252.255 3.211.756 1.665.87 2.51 2.241 2.51 4.076 0 1.03-.814 1.866-1.815 1.866h-7.98c-1.002 0-1.816-.837-1.816-1.866 0-1.864.823-3.24 2.446-4.092.94-.49 2.008-.74 3.18-.74h.264zm0 2h-.265c-.845 0-1.602.173-2.25.512-.925.485-1.34 1.143-1.373 2.186h7.607c-.033-1.024-.456-1.659-1.434-2.169-.67-.35-1.44-.529-2.285-.529zm-.085-9.097a3.234 3.234 0 013.23 3.23 3.234 3.234 0 01-3.23 3.23 3.234 3.234 0 01-3.23-3.23 3.234 3.234 0 013.23-3.23zm0 2c-.678 0-1.23.552-1.23 1.23a1.231 1.231 0 101.23-1.23z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoContacts = React.memo(Contacts);
export default MemoContacts;